/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    DynamicListAddButton,
    DynamicListWrapperProps,
    ValidatedDropDownList,
    ValidatedDynamicListFormComponentProps,
} from '@finbeat/react-toolkit';
import { Trans } from 'react-i18next';
import { Table } from 'reactstrap';
import { TradeOrgAddForm } from './TradeOrgChangeModal';

const TradeOrgIntegratorsFormWrapper = ({ children, ...props }: DynamicListWrapperProps) => {
    return (
        <Table bordered>
            <thead>
                <tr className="align-middle">
                    <th className="w-45 text-center">
                        <Trans i18nKey={'BackOfficeTradeOrg'} />
                    </th>
                    <th className="w-10 text-center">
                        <DynamicListAddButton {...props} />
                    </th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
};

const TradeOrgIntegratorsForm = ({
    idx,
    tradeOrgs,
    tradeOrgsFetching,
    formHasRole,
}: ValidatedDynamicListFormComponentProps & {
    tradeOrgs: DropDown[];
    tradeOrgsFetching: boolean;
    formHasRole: boolean;
}) => {
    return (
        <>
            <td>
                <ValidatedDropDownList<TradeOrgAddForm>
                    name={`integrators.list.${idx}.tradeOrgId`}
                    isFloating={false}
                    isClearable={false}
                    items={tradeOrgs}
                    isLoading={tradeOrgsFetching}
                    disabled={!formHasRole}
                />
            </td>
        </>
    );
};

export { TradeOrgIntegratorsForm, TradeOrgIntegratorsFormWrapper };
